<template>
    <div class="path">
        <!-- <Header /> -->
        <div class="container">
            <div v-if="question">
                <Form :question="question">
                    <h1 class="text-center question-heading">
                        {{ question.name }}
                        <span class="supporting" v-if="question.type == 'checkbox'">
                            Select up to 3
                        </span>
                    </h1>
                </Form>
            </div>
        </div>

        <Drawer
            v-if="question && question.type == 'checkbox' && !question.hideDrawer"
            :question="question"
        />
    </div>
</template>

<script>
// @ is an alias to /src
import Form from "@/components/Form.vue";
import Drawer from "@/components/Drawer.vue";

import { mapState } from "vuex";
// import Data from "./Data.vue";

export default {
    name: "Path",
    props: ["question"],
    components: {
        Form,
        // Data,
        // Header,
        Drawer
    },
    computed: {
        ...mapState({
            pathway: (state) => state.pathway,
            results: (state) => state.results,
        }),
    },
};
</script>

<style scoped>

.container {
    position: relative;
}

.path {
    display: flex;
    flex-direction: column;
    /* height: 100vh; */
    padding-top: 1rem;
    padding-bottom: 150px;
}

.text-center {
    text-align: center;
}

.question-heading {
    color: var(--c-red);
    font-size: 18px;
    font-weight: normal;
    margin-top: 0;
    margin-bottom: 4rem;
    padding: 0 4rem;
}

@media (min-width: 900px) {
    .question-heading {
        font-size: 32px;
        padding: 2rem 10rem;
    }
}

.question-heading .supporting {
    display: block;
    font-size: 18px;
    margin-top: 0.5rem;
}

</style>
